var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"person-with-badge-container"},[_c('div',{staticClass:"badge",attrs:{"tabindex":"0","role":"definition"}},[_vm._v(_vm._s(_vm.badgeCount))]),_c('img',{staticClass:"icon",class:_vm.iconColor,attrs:{"src":_vm.personIconUrl,"alt":"Manage group order","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }